import { Component, OnInit } from '@angular/core';
import { KursanciService } from '../services/kursanci.service';
import { ActivatedRoute } from '@angular/router';
import { Observable } from "rxjs/Observable";

@Component({
  selector: 'app-kursant-grupa',
  templateUrl: './kursant-grupa.component.html',
  styleUrls: ['./kursant-grupa.component.scss']
})
export class KursantGrupaComponent implements OnInit {

    $key;
    grupaId$;
    kursanciByGrupaId$;
    kursantGrupa$;
    loadedCharacter: {};

    constructor(
      private route: ActivatedRoute,
      private kursanciService: KursanciService,
  ) {}

  ngOnInit() {

      this.grupaId$ = this.route.params
          .switchMap(param => {
              this.$key = param['$key'];
              return this.kursanciService.findGrupaByKey(this.$key).snapshotChanges();
          })
          .do(res => console.log('findGrupaByKey():', res));

      // this.kursanciByGrupaId$ = this.route.params
      //     .switchMap(param => {
      //         this.$key = param['$key'];
      //         return this.kursanciService.getKursanciByGrupaId(this.$key)
      //     })
      //     .do(res => console.log('kursanciByGrupaId$():', res));
      //
      // this.kursantGrupa$ = this.route.params
      //     .switchMap(param => {
      //         this.$key = param['$key'];
      //         return this.kursanciService.getKursantGrupaDetails(this.$key)
      //     })
      //     .do(res => console.log('kursanciByGrupaId$():', res));



  }
}





// WEBPACK FOOTER //
// ./src/app/kursant-grupa/kursant-grupa.component.ts